export const SET_SIGNING_VIEW_PENDING = 'SET_SIGNING_VIEW_PENDING'
export const SET_SIGNING_VIEW = 'SET_SIGNING_VIEW'
export const SET_SIGNING_VIEW_ERROR = 'SET_SIGNING_VIEW_ERROR'
export const SET_NDA_SIGNING_VIEW_PENDING = 'SET_NDA_SIGNING_VIEW_PENDING'
export const SET_NDA_SIGNING_VIEW_ERROR = 'SET_NDA_SIGNING_VIEW_ERROR'
